import React from "react";
import { Shield, ExternalLink } from "lucide-react";

import "./DashboardActionCard.css";

export default function DashboardActionCard({
  eyebrow,
  title,
  description,
  buttonLabel,
  onClick,
  badge,
  variant = "primary",

  secondaryButtonLabel,
  onSecondaryClick,
}) {
  return (
    <div className={`hb-action-card hb-action-card--${variant}`}>
      <div className="hb-action-card__decor">
        <span className="hb-action-card__circle hb-action-card__circle--one" />
        <span className="hb-action-card__circle hb-action-card__circle--two" />
      </div>

      <div className="hb-action-card__content">
        {eyebrow && <p className="hb-action-card__eyebrow">{eyebrow}</p>}

        <h3 className="hb-action-card__title">{title}</h3>

        <p className="hb-action-card__description">{description}</p>

        {badge && (
          <div className="hb-action-card__badge">
            <Shield size={16} strokeWidth={2} />

            <span>{badge}</span>
          </div>
        )}

        <div className="hb-action-card__actions">
          <button
            type="button"
            className="hb-action-card__button"
            onClick={onClick}
          >
            {buttonLabel}
          </button>

          {secondaryButtonLabel && onSecondaryClick && (
            <button
              type="button"
              className="hb-action-card__secondary-button"
              onClick={onSecondaryClick}
            >
              <ExternalLink size={14} strokeWidth={2} />

              <span>{secondaryButtonLabel}</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
